import React, { Component, RefObject, createRef, KeyboardEvent } from 'react';
import { X } from 'react-feather';
import cn from 'classnames';
import AutoresizableInput from './autoresizableInput';

interface IProps {
  defaultValue: { key: string; val: string };
  replace: (prevKey: string, key: string, newValue: string) => void;
  update: (key: string, newValue: string) => void;
  remove: (key: string) => void;
}

interface IState {
  valid: boolean;
}

class StringMapInput extends Component<IProps, IState> {
  state: IState = { valid: true };

  autoResizableInputKey: RefObject<AutoresizableInput> = createRef();

  autoResizableInputValue: RefObject<AutoresizableInput> = createRef();

  updateHandler = () => {
    const { defaultValue, replace, update } = this.props;
    const prevKey = defaultValue.key;
    const prevValue = defaultValue.val;
    const key = this.autoResizableInputKey.current?.value;
    const val = this.autoResizableInputValue.current?.value;

    if (key && val) {
      if (prevKey !== key) {
        replace(prevKey, key, val);
      } else if (prevValue !== val) {
        update(key, val);
      }
    }
  };

  deleteHandler = () => {
    const { remove } = this.props;
    const key = this.autoResizableInputKey.current?.value;

    if (key) {
      remove(key);
    }
  };

  keyHandler = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.keyCode === 13) {
      this.updateHandler();
    }
  };

  render() {
    const { defaultValue } = this.props;
    const { valid } = this.state;

    return (
      <div className="cc-mapInputs__wrapper">
        <AutoresizableInput
          type="text"
          defaultValue={defaultValue.key}
          className={cn('cc-input', { invalid: !valid })}
          ref={this.autoResizableInputKey}
          onBlur={this.updateHandler}
          onKeyDown={this.keyHandler}
        />
        <AutoresizableInput
          type="text"
          defaultValue={defaultValue.val}
          className={cn('cc-input', { invalid: !valid })}
          ref={this.autoResizableInputValue}
          onBlur={this.updateHandler}
          onKeyDown={this.keyHandler}
        />

        <button tabIndex={-1} className="button-icon" type="button" onClick={this.deleteHandler}>
          <X size={12} />
        </button>
      </div>
    );
  }
}

export default StringMapInput;
